import React from 'react';
import TouchableElement from '@components/common/touchableElement';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg from '@styles/icons/svg';
import { ColorFunction } from '@styles/colors/types';
import { ICON_BUTTON_PADDING } from '@v2/pages/common/constants/base.constants';

export interface ContextMenuButtonProps {
  onShowContextMenu?: (value: boolean) => void;
  showContextMenu: boolean;
  scale: ScaleFunction;
  C: ColorFunction;
  style?: StyleProp<ViewStyle>;
}

const ContextMenuButton = ({ scale, showContextMenu, onShowContextMenu, C, style }: ContextMenuButtonProps) => {
  return (
    <TouchableElement onPress={() => onShowContextMenu?.(!showContextMenu)}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              backgroundColor: showContextMenu ? C('Button/Light/Only Text pressed') : C(pressHoverColor('Button/Light/Only Text')),
              padding: scale(ICON_BUTTON_PADDING),
              borderRadius: scale(18),
              justifyContent: 'center',
              alignItems: 'center',
            },
            style,
          ]}
        >
          <Svg icon="more" width={scale(22)} height={scale(22)} color={'Link/Light/Primary'} />
        </View>
      )}
    </TouchableElement>
  );
};

export default ContextMenuButton;
